import { mallEntranceApi } from '../request'
import { apiPath } from '../api'

export const purchaseList = {
  addShopping: data => mallEntranceApi.post(apiPath.addShopping, data)
}
